import {GET_RECORDS, SET_RECORDS} from '../mutation-types';
import recordsApi from '../../api/records';
import Vue from 'vue';

function formatDate(timestamp) {
    if (!timestamp) return "";
    timestamp = parseInt(timestamp);
    let date = new Date(timestamp);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    return year + '/' + formatNum(month) + '/' + formatNum(day) + ' ' + formatNum(hour) + ':' + formatNum(minutes) + ':' + formatNum(seconds);
}

function formatNum(num) {
    let newNum = num + "";
    if (newNum.length == 1) {
        return "0" + newNum;
    }
    return newNum;
}

function getChannelName(channelId) {
    let name = {
        10001: 'Fortumo',
        10002: 'Fortumo',
        10003: 'Mol',
        10004: 'Mol',
        10005: 'BluePay',
        10006: 'BluePay',
        10007: 'Gash',
        10008: '1Pay',
        10009: 'VNPT',
        10010: 'Mimopay',
        10011: 'Mimopay',
        10012: 'Codapay',
        10013: 'Upay',
        10014: 'MyCard',
        10015: 'MyCard',
        10016: 'PayPal',
        10017: 'UniPin',
        10018: 'UniPin',
        10019: 'Paymentwall',
        10020: '支付宝',
        10022: '天天賺'
    };
    return name[parseInt(channelId)];
}

function getStatusName(statusCode) {
    let status = statusCode + '';
    let statusName = {
        '0': Vue.t('statusPending'),
        '50': Vue.t('statusPending'),
        '100': Vue.t('statusSuccess'),
        '-50': Vue.t('statusFail')
    };
    return statusName[status];
}

function formatRecords(recordsType, recordsData) {
    if (recordsData.length == 0) {
        return [];
    }
    let result = [];
    for (let i = 0; i < recordsData.length; i++) {
        let record = recordsData[i];
        let newRecord = {};
        newRecord.orderDate = formatDate(record.createDate);
        if (recordsType == 'consume') {
            newRecord.appName = record.appName;
            newRecord.goodsName = record.goodsName;
            newRecord.goodsPrice = record.currency + ' ' + record.totalMoney;
        } else {
            newRecord.channelName = getChannelName(record.payPlatformId);
            newRecord.rechargeAmount = record.currency + ' ' + record.totalMoney;
            newRecord.egPoint = record.egPoint;
        }
        newRecord.orderId = record.id;
        newRecord.orderStatus = getStatusName(record.status);
        result[i] = newRecord;
    }
    return result;
}

export default {
    state: {
        consumeRecords: [],
        rechargeRecords: []
    },
    getters: {
        consumeRecordsList: (state) => {
            let list = state.consumeRecords;
            if (list.length === 0) {
                return [];
            }
            return formatRecords('consume', list);
        },
        rechargeRecordsList: (state) => {
            let list = state.rechargeRecords;
            if (list.length === 0) {
                return [];
            }
            return formatRecords('recharge', list);
        }
    },
    mutations: {
        [SET_RECORDS](state, records) {
            if (records.recordsType === 'consume') {
                state.consumeRecords = records.data;
            } else {
                state.rechargeRecords = records.data;
            }
        }
    },
    actions: {
        [GET_RECORDS]({commit}, params) {
            return new Promise((resolve, reject) => {
                recordsApi.getRecords(params, (records) => {
                    commit(SET_RECORDS, records);
                    resolve();
                }, (errorCode) => {
                    reject(errorCode);
                })
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/module/records.js